import {
  apiAsignarAsignaturasEstudiante,
  apiInserarReglamentoEstudios,
  apiListaSeguroAccidentes,
  apiReglamentoEstudios,
} from "../config/constantes";



const prometeValidarApi = (api, config) => {
  return new Promise((resolver, rechazar) => {
    fetch(api, config).then((data) => {

      if (data.status == 200) {
        resolver(data);
      } else {
        rechazar(new Error(data));
      }
    });
  });
};

let insert_reglamentosAceptados = async (datosEstudiante, inputs) => {

  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;
  const { cdocumento, baceptado } = inputs;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cpersona: Number(cpersona),
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cdocumento: cdocumento,
        p_baceptado: baceptado,
      }),
    };
    try {
      const insertReglamentosAceptados = await prometeValidarApi(
        `${apiInserarReglamentoEstudios}`,
        config
      );

      const insertReglamentosAceptadosJson =
        await insertReglamentosAceptados.json();
      const { Data } = insertReglamentosAceptadosJson;
      return insertReglamentosAceptadosJson;

    } catch (error) {
      throw error;
    }
  }
};

let reglamentoEstudio = async (datosEstudiante, setObtenerReglamentoEstudios, setLoading) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: cinstitucion,
        p_cprograma: cprograma,
        p_cperiodo: cperiodo,
        p_cpersona: cpersona,
      }),
    };
    try {

      setLoading(true);
      const lstReglamento = await prometeValidarApi(
        `${apiReglamentoEstudios}`,
        config
      );
      const lstReglamentoJson = await lstReglamento.json();
      const { Data } = lstReglamentoJson;
      setObtenerReglamentoEstudios(Data);

    } catch (error) {
      setLoading(false);
      throw error
    } finally {
      setLoading(false);
    }
  }
};



let asignar_asignatura_estudiante = async (datosEstudiante, inputs) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cpersona, cinstitucion, cprograma, cperiodo, dperiodo, calumno } = datosEstudiante;
  const { casignatura, cgrupo, nvez, cadena_asignaturas, agregado, sequivalente, scurso, sgrupo, ccurso_origen, ccurso_equivalente } = inputs;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_casignatura: Number(casignatura),
        p_cgrupo: Number(cgrupo),
        p_nvez: Number(nvez),
        p_cadena_asignaturas: String(cadena_asignaturas),
        p_agregado: Number(agregado),
        p_calumno: Number(calumno),
        p_dperiodo: String(dperiodo),
        p_scurso: String(scurso),
        p_sequivalente: String(sequivalente),
        p_sgrupo: String(sgrupo),
        p_ccurso_origen: ccurso_origen,
        p_ccurso_equivalente: ccurso_equivalente,
      }),
    };
    try {
      const asignarAsignaturasEstudiante = await prometeValidarApi(
        `${apiAsignarAsignaturasEstudiante}`,
        config
      );

      const asignarAsignaturasEstudianteJson =
        await asignarAsignaturasEstudiante.json();
      const { Data } = asignarAsignaturasEstudianteJson;

      return asignarAsignaturasEstudianteJson;

    } catch (error) {
      throw error
    }
  }
};


let listado_seguros = async (datosEstudiante, setObtenerSegurosAccidentesEstudiante, setLoading, setStatusDatosEstudianteSeguro) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cpersona, cinstitucion, cprograma, cperiodo } = datosEstudiante;

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cpersona: cpersona,
      p_cinstitucion: cinstitucion,
      p_cprograma: cprograma,
      p_cperiodo: cperiodo,

    }),
  };
  try {
    setLoading(true);
    const lstSeguroAccidentes = await prometeValidarApi(
      `${apiListaSeguroAccidentes}`,
      config
    );
    const lstSeguroAccidentesJson = await lstSeguroAccidentes.json();

    setStatusDatosEstudianteSeguro(lstSeguroAccidentesJson?.StatusCode);

    const { Data } = lstSeguroAccidentesJson;
    setObtenerSegurosAccidentesEstudiante(Data);

  } catch (error) {
  }
  finally {
    setLoading(false);
  }
};

export { insert_reglamentosAceptados, asignar_asignatura_estudiante, reglamentoEstudio, listado_seguros };
